import { useMemo } from 'react';
import { Text } from '@mercator-gcp/grout';
import CollectionDetailsBasic from 'components/widgets/Dashboard/PinnedProjects/CollectionDetailsBasic';
import { DEFAULT_COLLECTIONS } from 'components/widgets/Dashboard/PinnedProjects/constants';
import { useDefaultCollections } from 'hooks/useDefaultCollections';
import { usePaginate } from 'hooks/usePaginate';
import { useSavedProjects } from 'hooks/useSavedProjects';
import { useSortedProjects } from 'hooks/useSortedProjects';
import { CategoryEnum } from 'types/SavedProject';

const WatchedProjectsDetails = () => {
  const { page: currentPage } = usePaginate();
  const { sortArray } = useSortedProjects();
  const { getPaginatedSavedProjectsByCategory, getSavedProjectsByCategory } =
    useDefaultCollections();
  const { data: defaultCollectionsSummary } = getSavedProjectsByCategory;
  const { data: savedProjectList, isLoading: isLoadingSavedProjectList } =
    getPaginatedSavedProjectsByCategory({
      category: CategoryEnum.WATCH,
      pageNumber: currentPage,
      sort: sortArray,
    });
  const { getAllSavedProjectForUser } = useSavedProjects();
  const { data: allSavedProjectsDict } = getAllSavedProjectForUser;

  const filteredList = useMemo(() => {
    if (!savedProjectList?.results || !allSavedProjectsDict) {
      return [];
    }

    return savedProjectList?.results.filter(
      (item) => allSavedProjectsDict[item.slug]?.category === CategoryEnum.WATCH,
    );
  }, [savedProjectList, allSavedProjectsDict]);

  return (
    <CollectionDetailsBasic
      collectionName={DEFAULT_COLLECTIONS.ALL_WATCHED.label}
      collectionItems={filteredList}
      totalProjectCount={defaultCollectionsSummary?.number_of_watch_projects || 0}
      isLoading={isLoadingSavedProjectList}
      emptyPlaceholder={<Text>No watched projects</Text>}
    />
  );
};

export default WatchedProjectsDetails;
